import {
  ADD_MYSELF,
  ADD_MYSELF_FAILURE,
  ADD_MYSELF_SUCCESS,
  EDIT_MYSELF,
  EDIT_MYSELF_FAILURE,
  EDIT_MYSELF_SUCCESS,
} from '../Actiontype';

const initialState = {
  AddorEdituserSuccess: false,
  AddorEdituserSuccessMessage: '',
  AddorEdituserFailure: false,
  AddorEdituserFailureMessage: '',
  UserDetails: null,
};
export default function MySelfReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_MYSELF:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case ADD_MYSELF_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case ADD_MYSELF_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    case EDIT_MYSELF:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case EDIT_MYSELF_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case EDIT_MYSELF_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    default:
      return {
        ...state,
      };
  }
}
